import { forwardRef } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { useTranslations } from "next-intl";

import {
  DIALOG_CLOSE_ICON,
  type TDialogCloseElement,
  type TDialogCloseProps,
} from "@/ui/components/overlay/Dialog/Dialog.config";
import { cn } from "@/ui/lib";
import { Icon } from "../../primitives";

export const DialogClose = forwardRef<TDialogCloseElement, TDialogCloseProps>(
  ({ "aria-label": ariaLabel, ...props }, ref) => {
    const t = useTranslations("Libs.UI.Components.Dialog.DialogClose");

    return (
      <DialogPrimitive.Close
        aria-label={ariaLabel ?? t("close")}
        data-component="DialogClose"
        ref={ref}
        {...props}
        className={cn(
          "w-6 h-6",
          "absolute right-4 top-4 rounded-sys-sm opacity-70 transition-opacity",
          "hover:opacity-100",
          "focus:outline focus:outline-2 focus:outline-offset-0 focus:outline-sys-chartreuse-600",
          "disabled:pointer-events-none",
          "text-foreground",
        )}
      >
        <Icon icon={DIALOG_CLOSE_ICON} />
      </DialogPrimitive.Close>
    );
  },
);

DialogClose.displayName = DialogPrimitive.Close.displayName;
